'use strict';

require("core-js/modules/es6.object.define-properties.js");

require("core-js/modules/es6.object.freeze.js");

require("core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n\n  & .rcs-header {\n    font-family: \'-apple-system\', BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen,\n      Ubuntu, Cantarell, \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif;\n    font-size: 24px;\n    line-height: 1;\n    margin: 0 0 0.5em 0;\n    text-align: center;\n  }\n\n  & .rcs-buttons {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n\n  & .rcs-header {\n    font-family: \'-apple-system\', BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen,\n      Ubuntu, Cantarell, \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif;\n    font-size: 24px;\n    line-height: 1;\n    margin: 0 0 0.5em 0;\n    text-align: center;\n  }\n\n  & .rcs-buttons {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n  }\n']);

var _emotion = require('emotion');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ShareBlock = require('../ShareBlock');

var _ShareBlock2 = _interopRequireDefault(_ShareBlock);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var styles = (0, _emotion.css)(_templateObject);

var ShareBlockStandard = function ShareBlockStandard(props) {
  var _props$header = props.header,
      header = _props$header === undefined ? '' : _props$header,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;
  return _react2["default"].createElement('div', {
    className: (0, _emotion.cx)(styles, className)
  }, header && _react2["default"].createElement('p', {
    className: 'rcs-header'
  }, header), _react2["default"].createElement(_ShareBlock2["default"], props));
};

ShareBlockStandard.propTypes = {
  header: _propTypes2["default"].string,
  className: _propTypes2["default"].any
};
exports["default"] = ShareBlockStandard;